var n = /* @__PURE__ */ ((r) => (r.Ranking = "ranking", r.Bulk = "bulk", r))(n || {}), e = /* @__PURE__ */ ((r) => (r.RankingConfetti = "ranking_confetti", r.RankingSuccess = "ranking_success", r.RankingError = "ranking_error", r))(e || {}), a = /* @__PURE__ */ ((r) => (r.BulkReplyTemplate = "bulk_reply_template", r))(a || {});
export {
  a as CoverBulkEnum,
  n as CoverCategoryEnum,
  e as CoverRankingEnum
};
